import { AnswerType } from 'domains/models/answer/answerType';
import { z } from 'zod';

export const AnswerTypeEnum = z.nativeEnum(AnswerType);
